import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Event, EventDefinition, EventListGetResponse, EventProtocol, EventListQuery, NotificableEvent, CreateEventProtocol, CreateEventDefinition } from '../../../shared/interfaces/event.interfaces';

export const EventActions = createActionGroup({
  source: 'Event',
  events: {
    'Load All Events': props<{ EventListQuery: EventListQuery }>(),
    'Load All Events Success': props<{ data: EventListGetResponse }>(),

    'Load Account Events': props<{ accountId: number, EventListQuery: EventListQuery }>(),
    'Load Account Events Success': props<{ data: EventListGetResponse }>(),

    'Load Event By Id': props<{ eventId: number }>(),
    'Load Event By Id Success': props<{ data: Event }>(),

    'Load Event Protocols': emptyProps(),
    'Load Event Protocols Success': props<{ data: EventProtocol[] }>(),

    'Create Event Protocol': props<{ payload: CreateEventProtocol }>(),
    'Create Event Protocol Success': props<{ data: EventProtocol }>(),

    'Update Event Protocol': props<{ payload: EventProtocol }>(),
    'Update Event Protocol Success': emptyProps(),

    'Delete Event Protocol': props<{ id: number }>(),
    'Delete Event Protocol Success': props<{ id: number }>(),

    'Load Event Protocol By Id': props<{ id: number }>(),
    'Load Event Protocol By Id Success': props<{ data: EventProtocol }>(),

    'Load Event Definitions': emptyProps(),
    'Load Event Definitions Success': props<{ data: EventDefinition[] }>(),

    'Create Event Definition': props<{ payload: CreateEventDefinition }>(),
    'Create Event Definition Success': props<{ data: EventDefinition }>(),

    'Update Event Definition': props<{ payload: EventDefinition }>(),
    'Update Event Definition Success': emptyProps(),

    'Delete Event Definition': props<{ id: number }>(),
    'Delete Event Definition Success': props<{ data: EventDefinition }>(),

    'Load Event Definition By Id': props<{ id: number }>(),
    'Load Event Definition By Id Success': props<{ data: EventDefinition }>(),

    'Filter Notificable Events': props<{ payload: EventDefinition[] | undefined }>(),
    'Filter Notificable Events Success': props<{ data: NotificableEvent[] }>(),
    'Unset Notificable Events': emptyProps(),

    'Unset Event Store': emptyProps(),
  }
});
